<script lang="ts">
	import type { Icon } from './Icon-types';
	export let icon: Icon = 'hub';
	export let className = '';
	export let color = 'black';
	export let size = '';
	export let onClick: undefined | (() => void) = undefined;
	export let ref = undefined;
	export let clickable = false;
	export let sizeUnit: 'px' | 'rem' = 'px';

	let combinedClassName: string;
	$: combinedClassName = `icon px-icon px-icon-${icon} ${className} ${
		clickable ? 'clickable' : ''
	} ${typeof onClick === 'function' ? 'px-icon-has-link' : ''} `;
</script>

{#if onClick}
	<button
		type="button"
		bind:this={ref}
		class={`${combinedClassName} clickable`}
		style="

 --iconColor:{color}; --iconSize:{size}{sizeUnit}"
		on:click={onClick}
	/>
{:else}
	<span
		bind:this={ref}
		class={`${combinedClassName}${onClick ? 'clickable' : ''}`}
		style="

 --iconColor:{color}; --iconSize:{size}{sizeUnit}"
	/>
{/if}

<style>
	.clickable {
		cursor: pointer;
	}

	button,
	span {
		display: inline-block;
		inline-size: fit-content;
		border: none;
		background-color: transparent;
		color: var(--iconColor);
		font-family: pressly-icons !important; /* stylelint-disable-line */
		font-size: var(--iconSize);
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		font-style: normal;
		font-variant: normal;
		font-weight: normal;
		line-height: 1;
		text-align: center;
		text-transform: none;
		vertical-align: middle;
		cursor: default;
	}

	.px-icon-menu::before {
		content: '\E600';
	}

	.px-icon-back::before {
		content: '\E601';
	}

	.px-icon-next::before {
		content: '\E80e';
	}

	.px-icon-options::before {
		content: '\E602';
	}

	.px-icon-stream::before {
		content: '\E603';
	}

	.px-icon-inbox::before {
		content: '\E917';
	}

	.px-icon-bookmark::before {
		content: '\E604';
	}

	.px-icon-feeds::before {
		content: '\E927';
	}

	.px-icon-megaphone::before {
		content: '\E91c';
	}

	.px-icon-amplify::before {
		content: '\E929';
	}

	.px-icon-bell::before {
		content: '\E605';
	}

	.px-icon-notify::before {
		content: '\E90a';
	}

	.px-icon-collections::before {
		content: '\E905';
	}

	.px-icon-search::before {
		content: '\E606';
	}

	.px-icon-search-small::before {
		content: '\E607';
	}

	.px-icon-compose::before {
		content: '\E608';
	}

	.px-icon-create::before {
		content: '\E923';
	}

	.px-icon-manage::before {
		content: '\E60d';
	}

	.px-icon-edit::before {
		content: '\E614';
	}

	.px-icon-submission::before {
		content: '\E925';
	}

	.px-icon-published::before {
		content: '\E926';
	}

	.px-icon-file::before {
		content: '\E922';
	}

	.px-icon-content::before {
		content: '\E924';
	}

	.px-icon-draft::before {
		content: '\E904';
	}

	.px-icon-like-old::before {
		content: '\E609';
	}

	.px-icon-comment-old::before {
		content: '\E60a';
	}

	.px-icon-view-old::before {
		content: '\E92a';
	}

	.px-icon-share-old::before {
		content: '\E91e';
	}

	.px-icon-like::before {
		content: '\E958';
	}

	.px-icon-comment::before {
		content: '\E959';
	}

	.px-icon-view::before {
		content: '\E957';
	}

	.px-icon-share::before {
		content: '\E960';
	}

	.px-icon-like-uncolored::before {
		content: '\E953';
	}

	.px-icon-comment-uncolored::before {
		content: '\E954';
	}

	.px-icon-view-uncolored::before {
		content: '\E952';
	}

	.px-icon-share-uncolored::before {
		content: '\E955';
	}

	.px-icon-bar-graph::before {
		content: '\E956';
	}

	.px-icon-networks::before {
		content: '\E60b';
	}

	.px-icon-hub::before {
		content: '\E942';
	}

	.px-icon-tags::before {
		content: '\E90f';
	}

	.px-icon-tag::before {
		content: '\E916';
	}

	.px-icon-template::before {
		content: '\E921';
	}

	.px-icon-team::before {
		content: '\E60c';
	}

	.px-icon-profile::before {
		content: '\E800';
	}

	.px-icon-user::before {
		content: '\E918';
	}

	.px-icon-design::before {
		content: '\E60e';
	}

	.px-icon-analytics::before {
		content: '\E60f';
	}

	.px-icon-integrations::before {
		content: '\E611';
	}

	.px-icon-accounts::before {
		content: '\E612';
	}

	.px-icon-settings::before {
		content: '\E613';
	}

	.px-icon-ctas::before {
		content: '\E610';
	}

	.px-icon-poll::before {
		content: '\E903';
	}

	.px-icon-grid::before {
		content: '\E813';
	}

	.px-icon-hubs::before {
		content: '\E91a';
	}

	.px-icon-addons::before {
		content: '\E900';
	}

	.px-icon-refresh::before {
		content: '\E91f';
	}

	.px-icon-resend::before {
		content: '\E91d';
	}

	.px-icon-responses::before {
		content: '\E91b';
	}

	.px-icon-feature::before {
		content: '\E615';
	}

	.px-icon-pin::before {
		content: '\E928';
	}

	.px-icon-hide-content::before {
		content: '\E617';
	}

	.px-icon-camera::before {
		content: '\E620';
	}

	.px-icon-no-image::before {
		content: '\E80f';
	}

	.px-icon-lock::before {
		content: '\E616';
	}

	.px-icon-add-image::before {
		content: '\E906';
	}

	.px-icon-lead-image::before {
		content: '\E915';
	}

	.px-icon-upload::before {
		content: '\E810';
	}

	.px-icon-download::before {
		content: '\E920';
	}

	.px-icon-target::before {
		content: '\E811';
	}

	.px-icon-delete::before {
		content: '\E621';
	}

	.px-icon-delete-small::before {
		content: '\E90e';
	}

	.px-icon-calendar::before {
		content: '\E911';
	}

	.px-icon-clock::before {
		content: '\E912';
	}

	.px-icon-time::before {
		content: '\E913';
	}

	.px-icon-warning::before {
		content: '\E908';
	}

	.px-icon-title::before {
		content: '\E919';
	}

	.px-icon-bold::before {
		content: '\E92b';
	}

	.px-icon-italic::before {
		content: '\E92c';
	}

	.px-icon-underline::before {
		content: '\E92d';
	}

	.px-icon-strikethrough::before {
		content: '\E92e';
	}

	.px-icon-superscript::before {
		content: '\E937';
	}

	.px-icon-subscript::before {
		content: '\E938';
	}

	.px-icon-code::before {
		content: '\E92f';
	}

	.px-icon-link::before {
		content: '\E902';
	}

	.px-icon-quote::before {
		content: '\E930';
	}

	.px-icon-heading::before {
		content: '\E931';
	}

	.px-icon-subheading::before {
		content: '\E932';
	}

	.px-icon-bullet-list::before {
		content: '\E907';
	}

	.px-icon-numbered-list::before {
		content: '\E939';
	}

	.px-icon-paragraph-align-left::before {
		content: '\E93a';
	}

	.px-icon-paragraph-align-center::before {
		content: '\E93b';
	}

	.px-icon-paragraph-align-right::before {
		content: '\E93c';
	}

	.px-icon-paragraph-align-justify::before {
		content: '\E93d';
	}

	.px-icon-indent::before {
		content: '\E93e';
	}

	.px-icon-outdent::before {
		content: '\E93f';
	}

	.px-icon-table::before {
		content: '\E940';
	}

	.px-icon-full-width::before {
		content: '\E933';
	}

	.px-icon-align-left::before {
		content: '\E941';
	}

	.px-icon-align-right::before {
		content: '\E934';
	}

	.px-icon-close::before {
		content: '\E618';
	}

	.px-icon-add::before {
		content: '\E619';
	}

	.px-icon-add-small::before {
		content: '\E61a';
	}

	.px-icon-check::before {
		content: '\E61b';
	}

	.px-icon-check-small::before {
		content: '\E61c';
	}

	.px-icon-left-chevron::before {
		content: '\E801';
	}

	.px-icon-right-chevron::before {
		content: '\E61d';
	}

	.px-icon-chevron-dropdown::before {
		content: '\E61e';
	}

	.px-icon-chevron-up::before {
		content: '\E901';
	}

	.px-icon-dropdown-arrow::before {
		content: '\E61f';
	}

	.px-icon-switch::before {
		content: '\E909';
	}

	.px-icon-order::before {
		content: '\E910';
	}

	.px-icon-drag::before {
		content: '\E936';
	}

	.px-icon-newsletter::before {
		content: '\E943';
	}

	.px-icon-email::before {
		content: '\E90d';
	}

	.px-icon-invite::before {
		content: '\E90b';
	}

	.px-icon-phone::before {
		content: '\E935';
	}

	.px-icon-mention::before {
		content: '\E90c';
	}

	.px-icon-rss::before {
		content: '\E802';
	}

	.px-icon-twitter::before {
		content: '\E806';
	}

	.px-icon-facebook::before {
		content: '\E804';
	}

	.px-icon-gplus::before {
		content: '\E805';
	}

	.px-icon-google::before {
		content: '\E805';
	}

	.px-icon-linkedin::before {
		content: '\E812';
	}

	.px-icon-youtube::before {
		content: '\E807';
	}

	.px-icon-vimeo::before {
		content: '\E808';
	}

	.px-icon-instagram::before {
		content: '\E809';
	}

	.px-icon-soundcloud::before {
		content: '\E80a';
	}

	.px-icon-pinterest::before {
		content: '\E80b';
	}

	.px-icon-slack::before {
		content: '\E80c';
	}

	.px-icon-buffer::before {
		content: '\E914';
	}

	.px-icon-pressly::before {
		content: '\E80d';
	}

	.px-icon-embed::before {
		content: '\E944';
	}

	.px-icon-num-list::before {
		content: '\E945';
	}

	.px-icon-zoom-out::before {
		content: '\E946';
	}

	.px-icon-zoom-in::before {
		content: '\E947';
	}

	.px-icon-paragraph-styling::before {
		content: '\E948';
	}

	.px-icon-remove-styling::before {
		content: '\E949';
	}

	.px-icon-expand-link::before {
		content: '\Eb7e';
	}

	.px-icon-multishare::before {
		content: '\E94a';
	}

	.px-icon-text-scale::before {
		content: '\E94b';
	}

	.px-icon-to-arrow::before {
		content: '\E94c';
	}

	.px-icon-media::before {
		content: '\E94d';
	}

	.px-icon-repost::before {
		content: '\E94e';
	}

	.px-icon-survey::before {
		content: '\E94f';
	}

	.px-icon-discussion::before {
		content: '\E950';
	}

	.px-icon-hot::before {
		content: '\E951';
	}
</style>
